import { render, staticRenderFns } from "./posChannelIndex.vue?vue&type=template&id=6dfcbd76&"
import script from "./posChannelIndex.vue?vue&type=script&lang=js&"
export * from "./posChannelIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports